/**
 * "Copy as a new solution": the setup a solution was made from, carried
 * from Design's Setup section to Home's step-by-step form, which opens
 * prefilled with it. Held in memory for the one navigation between them.
 */
export interface SetupCopy {
  title: string;
  intro: string;
  brand: string;
  tone: string;
  tasks: { name: string; phrases: string }[];
}

/**
 * Kept briefly rather than taken once: Home can mount more than once on the
 * way in (its loading state, React's dev double-render), and each mount
 * needs to see it. Cleared when the form is left.
 */
const TTL_MS = 30_000;
let pending: { copy: SetupCopy; at: number } | null = null;

export const setPendingSetupCopy = (copy: SetupCopy) => {
  pending = { copy, at: Date.now() };
};

export const peekPendingSetupCopy = (): SetupCopy | null =>
  pending && Date.now() - pending.at < TTL_MS ? pending.copy : null;

export const clearPendingSetupCopy = () => {
  pending = null;
};
